export default [{
  path: '/engine/dashboard',
  name: 'engine-dashboard',
  component: () => import('./index.vue'),
  meta: { engine: true, requiresAdmin: true },
}]
